import React, { useEffect, useState } from "react";
import AllRoute from "../router/index";
import { gsap } from "gsap";
import { ToastContainer } from "react-toastify";
import ReactGA from "react-ga4";
import "react-toastify/dist/ReactToastify.css";
import "../../../node_modules/react-modal-video/scss/modal-video.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../css/fontawesome.css";
import "../../css/custom-animation.css";
import "../../css/themify-icons.css";
import "../../css/animate.css";
// import "../../css/style.css";
import "../../css/index.purged.css";

const App = () => {
  const TRACKING_ID = "G-K1360Y5FYP";
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    ReactGA.send("pageview"); // эхний нээлт дээр хуудасны хандалт бүртгэнэ
  }, []);

  useEffect(() => {
    // Баруун-товч цэс
    const onContext = (e) => e.preventDefault();
    // Зураг чирэх
    const onDragStart = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };
    // Copy, Cut, Paste бүгдийг хаах
    const onCopy = (e) => e.preventDefault();
    const onCut = (e) => e.preventDefault();
    const onPaste = (e) => e.preventDefault();
    // Текст сонгохыг хаах
    const onSelectStart = (e) => e.preventDefault();

    document.addEventListener("contextmenu", onContext);
    document.addEventListener("dragstart", onDragStart);
    document.addEventListener("copy", onCopy);
    document.addEventListener("cut", onCut);
    document.addEventListener("paste", onPaste);
    document.addEventListener("selectstart", onSelectStart);

    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("dragstart", onDragStart);
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("cut", onCut);
      document.removeEventListener("paste", onPaste);
      document.removeEventListener("selectstart", onSelectStart);
    };
  }, []);

  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("dark");
    setIsDark(stored === "true");
  }, []);

  const handleToggleDarkMode = () => {
    const newValue = !isDark;
    setIsDark(newValue);
    localStorage.setItem("dark", newValue);
  };

  useEffect(() => {
    gsap.set(".cursor-ball", { xPercent: -50, yPercent: -50 });
    let targets = gsap.utils.toArray(".cursor-ball");
    window.addEventListener("mousemove", (e) => {
      gsap.to(targets, {
        duration: 0.4,
        x: e.clientX,
        y: e.clientY,
        ease: "power1.out",
        overwrite: "auto",
        stagger: 0.05,
      });
    });
  }, []);

  return (
    <div className="App" id="scrool" data-theme={isDark ? "dark" : ""}>
      <AllRoute isDark={isDark} onToggleDark={handleToggleDarkMode} />
      <ToastContainer />
      <div className="cursor-ball"></div>
      <div className="cursor-ball inner-ball"></div>
    </div>
  );
};

export default App;
